var map = {
	"./1.png": 1494,
	"./10.png": 1495,
	"./2.png": 1496,
	"./3.png": 1497,
	"./4.png": 1498,
	"./5.png": 1499,
	"./6.png": 1500,
	"./7.png": 1501,
	"./8.png": 1502,
	"./9.png": 1503,
	"./answer.png": 805,
	"./background1.png": 804,
	"./background2.png": 803,
	"./background3.png": 802,
	"./background4.png": 801,
	"./ch1.png": 806,
	"./che1.png": 494,
	"./che2.png": 796,
	"./che3.png": 799,
	"./che4.png": 794,
	"./che5.png": 797,
	"./che6.png": 800,
	"./che7.png": 795,
	"./che8.png": 798,
	"./che9.png": 1504,
	"./complete.png": 793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;